<section class="search-page">
  <div class="no-search-content">
    <p class="subtitle mb-3">Corporate Affairs Commission, Nigeria</p>
    <h1 class="title heading-font heading-color-1">Beneficial Ownership Register</h1>
    <div class="search-box">
      <input
        [(ngModel)]="searchTerm"
        (ngModelChange)="hasError = false;"
        (keydown.enter)="onSearch()"
        class="form-control"
        [ngClass]="{'error': hasError}"
        placeholder="Search by company name, RC number, or PSC name..."
      />
      <div class="pt-4">
        <button class="btn btn-success" (click)="onSearch()">Search Registry</button>
      </div>
    </div>
  </div>
</section>
